<template>
    <div class="header-bar header-fixed header-app header-bar-detached">
        <!-- <a data-bs-toggle="offcanvas" data-bs-target="#menu-main" href="#" v-if="!$route.meta.isBack"></a> -->
        <a href="javascript:void(0)" v-if="$route.meta.isBack"><i class="bi bi-arrow-left-circle-fill" @click="back()"></i></a>
        <!-- <a href="#" class="header-title color-theme">{{ $route.meta.title }}</a> -->
        <div style="width: 150px; height: 50px;" :style="{ 'background-image': 'url('+require('@/assets/logo-digital-school.png')+')', 'object-fit': 'fill', 'flex-grow': 8,  'background-repeat': 'no-repeat', 'background-position': 'center' }"></div>
        <a href="javascript:void(0)" v-if="$route.meta.requiresAuth" @click="logout"><i class="bi bi-box-arrow-right font-16"></i></a>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'Header',
    methods: {
        ...mapActions(['forceLogout']),
        logout() {
            this.forceLogout()
            this.$router.push({ name: 'login' })
        }
        ,
        // ...mapActions('auth', ['logoutDummy']),
        // logout() {
        //     this.logoutDummy()
        //     // .then(() => {
        //         this.$router.push({ name: 'login' })
        //     // })
        // },
        back() {
            this.$router.back()

            // history.back()
            // window.location.reload(history.back())
            // window.location=document.referrer
        }
    }
}
</script>